import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { CourseService } from '../services/course.service';
import { CourseConstants } from '../constants/course.constants';
import { CourseDetail } from '../models/courseDetails';
import { CourseStatusConstants } from '../constants/courseStatus.constants';
import { EqmsScopeManagementService } from '../../shared/services/eqms-scope-management.service';
import { LinkedDocument } from '../../shared/models/linked-documents';
import { takeUntil, timer, Subject, forkJoin } from 'rxjs';
import { TrainingRequirement } from '../../training-requirement/models/training-requirement';
import { TrainingItemGroupManagementService } from '../../shared/components/training-item-group-management/services/training-item-group-management.service';
import { NameCode } from '../../shared/models/name-code';
import { TrainingItemGroupsLookupRequest } from '../../shared/components/training-item-group-management/models/training-item-groups-lookup-request';

@Component({
  selector: 'app-course-details',
  templateUrl: './course-details.component.html',
  styleUrls: ['./course-details.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CourseDetailsComponent implements OnInit{
  number!: string;
  isPageFound :boolean = true;
  isCourseFound:boolean = true;
  courseDetail!: CourseDetail;
  courseErrorMessage:string = CourseConstants.Course_CourseNotFound_ErrorMessage;
  topBarTitle: string = CourseConstants.Course_CourseDetailsTopBarTitle;
  courseInfoTitle: string =CourseConstants.Course_CourseInfoHeader;
  courseSummaryTitle: string = CourseConstants.Course_CourseSummaryHeader;
  courseDetailsHeader: string = CourseConstants.Course_CourseDetailsHeader;
  courseScoringHeader: string = CourseConstants.Course_CourseScoringHeader;
  coursePrerequisitesHeader: string = CourseConstants.Course_CoursePrerequisitesHeader;
  courseEquivalentCoursesHeader : string = CourseConstants.Course_CourseEquivalentCoursesHeader;
  areQualifiedTrainersPresent : boolean =true;
  isCourseProficiencyQuizSliderOpen: boolean = false;
  isCreateTrSliderOpen: boolean = false;
  courseMinimumPassingScore: string | null = null;
  @Input() isCourseSliderOpen: boolean = false;
    isInstuctorLedCourse: boolean = false;
    LinkText: string = CourseConstants.LinkText;
    courseDetailsLoader = true;
  trainingRequirement : TrainingRequirement = new TrainingRequirement();
    isTrainingItemGroupManagementSliderOpen: boolean = false;
    trainingItemGroups !: any;
  trainingItemGroupsForCourse:NameCode[] = [];
    trainingItemGroupsLookupRequest! : TrainingItemGroupsLookupRequest;
    loadTrainingDetails:boolean = true;
    private destroy$ = new Subject<void>();


  constructor(private router : Router, private courseService:CourseService,
    private eqmsScopeManagementService: EqmsScopeManagementService, 
    private trainingItemGroupManagementService: TrainingItemGroupManagementService){}
  
  
  
    ngOnInit(): void {
  const url = this.router.url;
  const courseParts = url.substring(url.lastIndexOf('/') + 1);

  if (url.includes(CourseConstants.Course_CourseDetailScreen)) {
    this.number = courseParts;

    if (this.isPageFound) {
      this.loadCourseData();
    }
  }
}

loadCourseData() {
  this.courseDetailsLoader = true;

  const course$ = this.courseService.getCourse(this.number);
  const trainingGroups$ = this.courseService.getTrainingItemGroupsForCourse(this.number);
  const eqmsLookup$ = this.eqmsScopeManagementService.geteQMSScopeLookup();

  forkJoin([course$, trainingGroups$, eqmsLookup$]).subscribe({
    next: ([course, trainingGroups, eQMSScopes]) => {
      // Fetching Course data
      this.courseDetail = course;
      this.trainingRequirement = this.getTrainingRequirement();
      this.areQualifiedTrainersPresent = !!this.courseDetail.qualifiedTrainers;
      this.isInstuctorLedCourse = this.courseDetail.format === CourseConstants.course_Format_InstructorLed_Value;
      this.courseMinimumPassingScore = this.courseDetail?.minimumPassingScore;
       this.courseDetailsLoader = false;

      // Fetching eQMS Scope information
      this.courseDetail.eQMSScopeDisplayNames = this.courseDetail.eqmsScopes?.map((id: number) => {
        const scope = eQMSScopes.find((e: any) => e.eQMSScopeId === id);
        return scope ? scope.eQMSScopeName : '';
      }) || [];

      // Fetching Training groups
      this.trainingItemGroups = trainingGroups;
      this.trainingItemGroupsForCourse = trainingGroups;
      this.loadTrainingDetails = true;

      // Stoping spinner once data is loaded
      this.courseDetailsLoader = false;
    },
    error: (err) => {
      this.courseErrorMessage = err?.error?.detail;
      this.isCourseFound = false;
      this.courseDetailsLoader = false;
    }
  });

  // Optional fallback in case of any issue
  setTimeout(() => {
    this.courseDetailsLoader = false;
  }, 20000);
}


ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

activeTabIndex: number = -1; // none of the tab is active initially

onTabChange(event: any) {
  this.activeTabIndex = event.index;
}

get isSessionTabActive(): boolean {
  return this.activeTabIndex === CourseConstants.Course_Details_Session_Tab_Index;
}
get isTrainingTabActive(): boolean {
  return this.activeTabIndex === ((this.isInstuctorLedCourse && CourseConstants.Course_Details_Training_Tab_InstructorLed_Index) 
  || CourseConstants.Course_Details_Training_Tab_SelfStudy_Index);
}

openPrerequisites(number: string, version: number | null, prerequisiteType?: number){
  if(prerequisiteType == CourseConstants.Course_PrerequisiteType_Document){
    const url = this.router.serializeUrl(
      this.router.createUrlTree([
        '/eqms.documentDetails/' + number + ':' + version?.toString(),
      ])
    );
    window.open(url, '_blank');
  }
  else if(prerequisiteType == CourseConstants.Course_PrerequisiteType_Course){
      var url = location.origin.concat("/training/eqms.courses/", number);
      window.open(url, "_blank");
  }
}

reloadCourseDetails() {
  this.loadCourseData();
}

loadeQMSScopeLookUp(){
  this.eqmsScopeManagementService.geteQMSScopeLookup().subscribe((eQMSScopes)=>{
    this.courseDetail.eqmsScopes.forEach((eQMSScopeData : number)=>{
      let eQMSScope = eQMSScopes.filter((e: { eQMSScopeId: number; }) => {return e.eQMSScopeId === eQMSScopeData});
      if(this.courseDetail.eQMSScopeDisplayNames === undefined 
        || this.courseDetail.eQMSScopeDisplayNames === null) 
        this.courseDetail.eQMSScopeDisplayNames = [];
      this.courseDetail.eQMSScopeDisplayNames?.push(eQMSScope[0].eQMSScopeName);
    })
  });
}

courseErrorMessages() : string{
  if (!this.isCourseFound) {
    return this.courseErrorMessage;
  }
  return '';
}

calculateStatusColor(status: string|undefined) : string{
  let statusColor = '';
  if(status === undefined) return statusColor;
  switch(status){
    case CourseStatusConstants.StatusName_Active:
      statusColor=CourseStatusConstants.StatusClassName_Active;
      break;
    case CourseStatusConstants.StatusName_Inactive:
      statusColor=CourseStatusConstants.StatusClassName_Inactive;
      break;
  }
  return statusColor;
}
editCourse()
{
   this.isCourseSliderOpen = !this.isCourseSliderOpen;
   this.courseService.editCourseSlider$.next(true);
}

closeSlider(isSliderActive : boolean){
  this.isCourseSliderOpen = false;
}

downloadAttachment = (fileId: string, fileName: string) => {
  this.courseService.downloadFile(fileId).subscribe((response) => {
    const fileUrl = response.fileUri;
    let downloadLink = document.createElement('a');
    document.body.appendChild(downloadLink);
    downloadLink.setAttribute('style', 'display: none');
    downloadLink.href = fileUrl;
    downloadLink.download = fileName;
    downloadLink.target = '_blank';
    downloadLink.click();
    downloadLink.remove();
  })
}

openLink(url:string | undefined){
  if(url !== undefined)
    window.open(url, "_blank");
  }

loadDocumentDetails = (documentNumber:string,version: number) => {
  const url = this.router.serializeUrl(
    this.router.createUrlTree([
      '/eqms.documentDetails/' + documentNumber + ':' + version,
    ])
  );
  window.open(url, '_blank');
};
trackByDocumentNumber = (index: number, document: LinkedDocument) => {
  return document.number;
}

openCourseProficiencyQuizSlider = () => {
  this.isCourseProficiencyQuizSliderOpen = true;
 }

 openCreateTrainingRequirementSlider = () => {  
  this.isCreateTrSliderOpen = true;
 }

 getTrainingRequirement() : TrainingRequirement {
  return {
    trainingItemType : 'Course',
    trainingItemId: this.courseDetail.courseNumber,
    documentVersionNumber : null
  };
 }

 closeCreateTrainingRequirementSlider = (isSliderActive: boolean) => {
  this.isCreateTrSliderOpen = isSliderActive;
}
 
 closeCourseProficiencyQuizSlider = (isSliderActive: boolean) => {
   this.isCourseProficiencyQuizSliderOpen = isSliderActive;
 }

 openTrainingItemGroupManagementSlider = () => {
  //call the service to get the training item group management data
  this.trainingItemGroupsLookupRequest =  {trainingItemType : 2, trainingItemId : this.number, documentVersionNumber : null}
  this.trainingItemGroupManagementService.getTrainingItemGroupsLookup(this.trainingItemGroupsLookupRequest)
  this.isTrainingItemGroupManagementSliderOpen = true;
}

closeTrainingItemGroupManagementSlider(isSliderActive: boolean) {
  this.isTrainingItemGroupManagementSliderOpen = isSliderActive;
  this.reloadCourseDetails();
}
getTrainingItemGroups(){
  this.loadTrainingDetails = false;
  this.courseService.getTrainingItemGroupsForCourse(this.number).subscribe((response)=>{
    this.trainingItemGroups = response;
    this.trainingItemGroupsForCourse = this.trainingItemGroups;
    this.loadTrainingDetails = true;
  })
}

}
